export default __webpack_public_path__ + "static/media/comercial.7e7e0514.svg";